import { Fragment, useMemo, useState } from 'react';
import styled from 'styled-components';
import { Big } from 'foundations-components/transitional/components/Big';
import { BreakString } from 'foundations-components/transitional/components/BreakString';
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { Image } from 'foundations-components/transitional/components/Image';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Lightbox } from 'foundations-components/transitional/components/Lightbox';
import { Section } from 'foundations-components/transitional/components/Section';
import { useFocusCloseButton } from 'marketplace-ui-common/hooks/useFocusCloseButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const IMAGE_WIDTH = 280;
const FeatureParagraph = styled.p.withConfig({
  displayName: "FeatureCard__FeatureParagraph",
  componentId: "bj5rza-0"
})(["white-space:pre-line;"]);
export default function FeatureCard({
  children,
  feature,
  onImageClick
}) {
  const [showLightBox, setShowLightBox] = useState(false);
  useFocusCloseButton(showLightBox);
  const {
    title,
    description,
    imageUrl
  } = feature;
  const renderedLightbox = useMemo(() => showLightBox && feature.imageUrl && /*#__PURE__*/_jsx(Lightbox, {
    imageAlt: feature.description,
    imageSrc: feature.imageUrl,
    onClose: () => setShowLightBox(false),
    children: /*#__PURE__*/_jsx(ButtonWrapper, {
      children: feature.description
    })
  }), [feature, showLightBox, setShowLightBox]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(Section, {
      children: /*#__PURE__*/_jsxs(Grid, {
        children: [/*#__PURE__*/_jsxs(GridItem, {
          size: {
            sm: 12,
            md: 7
          },
          children: [/*#__PURE__*/_jsx(Big, {
            weight: "bold",
            children: /*#__PURE__*/_jsx(BreakString, {
              children: title
            })
          }), /*#__PURE__*/_jsx(FeatureParagraph, {
            children: /*#__PURE__*/_jsx(BreakString, {
              children: description
            })
          }), children]
        }), /*#__PURE__*/_jsx(GridItem, {
          size: {
            sm: 12,
            md: 5
          },
          children: imageUrl && /*#__PURE__*/_jsx(Clickable, {
            onClick: () => {
              setShowLightBox(true);
              if (onImageClick) {
                onImageClick();
              }
            },
            children: /*#__PURE__*/_jsx(Image, {
              alt: title,
              src: imageUrl,
              inlineSize: `${IMAGE_WIDTH}px`,
              responsive: true
            })
          })
        })]
      })
    }, `feature-${title}`), renderedLightbox]
  });
}